import WebSocketClient from '@/includes/WebSocketClient';
import axios from 'axios';

export default {
	namespaced: true,
	state: {
		socket: null,
		connected: false,
		notifications: [],
		showNewNotification: false,
	},
	mutations: {
		SET_SOCKET(state, socket) {
			state.socket = socket;
		},
		SET_CONNECTED(state, status) {
			state.connected = status;
		},
		ADD_NOTIFICATION(state, notification) {
			state.notifications.unshift(notification);
		},
		SET_NOTIFICATIONS(state, notifications) {
			state.notifications = notifications;
		},
		SET_SHOW_NEW_NOTIFICATION(state, show) {
			state.showNewNotification = show;
		},
		DELETE_NOTIFICATION(state, code) {
			state.notifications = state.notifications.filter(n => n.code !== code);
		},
		MARK_AS_READ(state, code) {
			const notification = state.notifications.find(n => n.code === code);
			if (notification) {
				notification.read = true;
			}
		},
		MARK_ALL_AS_READ(state) {
			state.notifications = state.notifications.map(n => ({ ...n, read: true }));
		},
		DELETE_ALL_READ_NOTIFICATIONS(state) {
			state.notifications = state.notifications.filter(n => !n.read);
		}
	},
	actions: {
		init({ commit, state, rootState }) {
			// Получаем уведомления
			axios.post('GetNotifications', { no_loader: true, data: {} }).then(res => {
				commit('SET_NOTIFICATIONS', res.data.body.tables.messages.colvalues);
			});

			if (state.socket) {
				console.log('[Notifications] WebSocket уже инициализирован');
				return;
			}
			const socketToken = rootState.userData?.user_info_advanced?.socket_token;

			if (!socketToken) {
				console.error('[Notifications] Не найден socket_token');
				return;
			}

			const socket = new WebSocketClient({
				url: `ws://home.paypoint.pro:32151/api/informator/ws?auth_token=${socketToken}`,
			});

			socket
				.onOpen(() => {
					commit('SET_CONNECTED', true);
				})
				.onError((error) => {
					console.log('error', error);
				})
				.onMessage((data) => {
					console.log('message', data)
					commit('SET_SHOW_NEW_NOTIFICATION', true);
				})
				.onClose(() => {
					commit('SET_CONNECTED', false);
				})
				.connect();

			commit('SET_SOCKET', socket);
		},
		close({ state, commit }) {
			if (state.socket) {
				state.socket.disconnect();
				commit('SET_SOCKET', null);
				commit('SET_CONNECTED', false);
			}
		},
	},
	getters: {
		isConnected: state => state.connected,
		notifications: state => state.notifications,
		unreadNotifications: state => state.notifications.filter(n => !n.read),
		readNotifications: state => state.notifications.filter(n => n.read),
		hasUnread: state => state.notifications.filter(n => !n.read).length > 0,
		unreadTodayCount: state => {
			const startOfDay = new Date();
			startOfDay.setHours(0, 0, 0, 0);
			const startTimestamp = startOfDay.getTime();
			const endTimestamp = startTimestamp + 24 * 60 * 60 * 1000;

			const toMillis = (ts) => (ts < 1e12 ? ts * 1000 : ts);

			return state.notifications.filter((notification) => {
				if (notification.read) {
					return false;
				}
				const createdAt = toMillis(notification.ts_create);
				return createdAt >= startTimestamp && createdAt < endTimestamp;
			}).length;
		}
	}
};